/** @jsxImportSource @emotion/react */
import React from 'react';
import Location from './location.component';

export const LocationWrapper = () => <Location />;
